// extracted by mini-css-extract-plugin
module.exports = {"container":"reactions_container__2tQ81","header":"reactions_header__2smbI","more":"reactions_more__3k0rY","reactions":"reactions_reactions__3cO67"};